import { HintField, LabelField } from "components";
import React, { memo } from "react";

export const TextareaField = memo(
  ({
    title,
    rows,
    name,
    style,
    type,
    rules,
    error,
    labelFieldClass,
    formik,
    checkValidation = false,
    mandatory = false,
    titleStyle,
    ...rest
  }) => {
    const getInputClasses = () => {
      if (!checkValidation) {
        return "";
      }

      if (formik.touched[name] && formik.errors[name]) {
        return "is-invalid";
      }

      if (formik.touched[name] && !formik.errors[name]) {
        return "is-valid";
      }

      return "";
    };

    return (
      <div className="form-group fv-plugins-icon-container">
        <LabelField
          htmlFor={name}
          title={title}
          mandatory={mandatory}
          labelClassName={labelFieldClass}
          style={titleStyle || {}}
        />
        <textarea
          rows={rows}
          id={name}
          style={style}
          className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses()}`}
          {...rest}
          {...formik.getFieldProps(name)}
        />
        {formik.touched[name] && formik.errors[name] ? (
          <HintField error={formik.errors[name]} />
        ) : null}
      </div>
    );
  }
);
